export const BILLIT_PENDING_ASSIGNED_REFRESH_EVENT = 'billit-pending-assigned-refresh';

const fetchPendingAssignedInvoiceCount = async (
  getAccessToken: () => Promise<string>,
): Promise<number> => {
  const token = await getAccessToken();
  const response = await fetch(
    `${process.env.REACT_APP_BACKEND_URI}/billit/invoices/assigned/me/pending-count`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    },
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  return Number(data.count) || 0;
};

export default fetchPendingAssignedInvoiceCount;

export const refreshBillitPendingAssignedBanner = () => {
  window.dispatchEvent(new Event(BILLIT_PENDING_ASSIGNED_REFRESH_EVENT));
};
